<div class="html-container">
  <mat-form-field appearance="outline" class="textWrapper">
    <mat-label class="textLabel">{{ question.question.caption }}</mat-label>
    @if (!question.question.additionalPropertiesParsed.IsMultiLine) {
    <div>
      <input
        matInput
        placeholder="{{
          question.question.additionalPropertiesParsed.PlaceHolder
        }}"
        [formControl]="textFormControl"
        (change)="saveComment(textFormControl.value)"
      />
    </div>
    } @else {
    <textarea
      matInput
      placeholder="{{
        question.question.additionalPropertiesParsed.PlaceHolder
      }}"
      [formControl]="textFormControl"
      (change)="saveComment(textFormControl.value)"
    >
    </textarea>
    } @if (textFormControl.hasError('minlength')) {
    <mat-error>
      {{
        ("induction_error_comment_min_length" | translate).replace(
          "{minLength}",
          this.question.question.additionalPropertiesParsed.MinLength
        )
      }}
    </mat-error>
    } @if (textFormControl.hasError('maxlength')) {
    <mat-error>
      {{
        ("induction_error_comment_max_length" | translate).replace(
          "{maxLength}",
          this.question.question.additionalPropertiesParsed.MaxLength
        )
      }}
    </mat-error>
    }
  </mat-form-field>
</div>
